// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_8w-0";
export var optionCard = "_8w-1";